import globalAxios, {
  type AxiosRequestConfig,
  type AxiosResponse,
} from "axios";
import { authService } from "../utils/authService";
import appLocalStorage from "./localStorage"; 

const requestHandler = async (request: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
  // 1. Lấy token B2C
  const b2cToken = authService.getAccessToken();
  const b2cRefreshToken = authService.getRefreshToken();
  
  // 2. Lấy token 3M từ storage LOGIN
  const storageToken = await appLocalStorage.getItem('LOGIN');

  // Logic gắn Header: Ưu tiên B2C, nếu không có thì dùng 3M
  if (b2cToken) {
    request.headers = {
      ...request.headers,
      Authorization: `Bearer ${String(b2cToken)}`,
      refresh_token: `${String(b2cRefreshToken)}`,
    };
  } else if (storageToken?.token) {
    request.headers = {
      ...request.headers,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      Authorization: `Bearer ${storageToken.token}`,
    };
  }

  return request;
};

globalAxios.interceptors.request.use(
  async (request) => await requestHandler(request),
  (error) => Promise.reject(error),
);

globalAxios.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: any) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      // CHỈ luồng B2C mới có khả năng refresh token
      const newToken = await authService.refreshToken();
      
      if (newToken) {
        originalRequest.headers.Authorization = `Bearer ${String(newToken)}`;
        return await globalAxios(originalRequest);
      }

      // TẤT CẢ các trường hợp còn lại (3M hết hạn hoặc B2C refresh fail)
      // Xóa sạch toàn bộ session
      authService.clearAuth(); 
      appLocalStorage.removeItem('LOGIN'); 

      // Điều hướng thẳng về login-options
      if (!window.location.pathname.includes("/login")) {
        window.location.href = "/login-options";
      }
    }

    return await Promise.reject(error);
  },
);
